import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = {
  class: "batch-operation-container"
};
const _hoisted_2 = {
  class: "filter-container"
};
const _hoisted_3 = {
  class: "input-filter"
};
const _hoisted_4 = {
  class: "input-filter"
};
const _hoisted_5 = {
  class: "batch-operation-table"
};
const _hoisted_6 = {
  class: "action-container"
};
const _hoisted_7 = ["href"];
const _hoisted_8 = ["href"];
const _hoisted_9 = {
  class: "batch-operation-btn mt-10"
};
import { computed, onMounted, ref, reactive, toRaw, toRefs, watch } from 'vue';
import { alarmQueryAll } from '@/api/management/batchOperation';
import { serverTypeListApi } from '@/api/home/globalSearch';
import { Search, Plus, Minus, EditPen, CaretRight } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import BatchMoveDialog from './batch-move-dialog.vue';
import BatchMaintainDialog from './batch-maintain-dialog.vue';
import BatchUnmaintainDialog from './batch-unmaintain-dialog.vue';
import BatchDeleteDialog from './batch-delete-dialog.vue';
import { deepClone } from '@/utils/util';
import { useManualTestStore } from '@/store/manualTest';
import { useBatchOperationStore } from '@/store/batchOperation';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    searchValue: {}
  },
  emits: ["resetSearchValue"],
  setup(__props, {
    emit: __emit
  }) {
    const batchOperationStore = useBatchOperationStore();
    const {
      refreshTable
    } = storeToRefs(batchOperationStore);
    const manualTestStore = useManualTestStore();
    const {
      showManualTestTrigger
    } = manualTestStore;
    const props = __props;
    const {
      searchValue
    } = toRefs(props);
    const filters = reactive({
      alerting: false,
      unack: false,
      excludeId: '',
      maintainStatus: '',
      clusterName: '',
      dc: '',
      url: '',
      serverName: '',
      serverType: '',
      service: '',
      svrtype: '',
      zoneName: ''
    });
    const serverTypeList = ref([]);
    const getServerTypeList = async () => {
      if (serverTypeList.value.length) return;
      const {
        svrTypeMappingList
      } = await serverTypeListApi();
      serverTypeList.value = svrTypeMappingList;
    };
    const isShowMoreFilters = ref(false);
    const showMoreFilters = () => {
      isShowMoreFilters.value = !isShowMoreFilters.value;
      !serverTypeList.value?.length && getServerTypeList();
    };
    const string2percentage = str => {
      if (!str) {
        return 0;
      }
      const [numeratorStr, denominatorStr] = str.split('/');
      const numerator = numeratorStr ?? '' !== '' ? Number(numeratorStr) : 0;
      const denominator = denominatorStr ?? '' !== '' ? Number(denominatorStr) : 0;
      if (denominator === 0) {
        return 0;
      } else {
        return Math.floor(numerator / denominator * 100);
      }
    };
    const emits = __emit;
    const resetSearch = () => {
      let res = [];
      if (filters.clusterName ?? '' !== '') {
        res = ['0', filters.clusterName];
      }
      if (filters.zoneName ?? '' !== '') {
        res = ['3', filters.zoneName];
      }
      if (filters.url ?? '' !== '') {
        res = ['2', filters.url];
      }
      if (filters.serverName ?? '' !== '') {
        res = ['1', filters.serverName];
      }
      emits('resetSearchValue', res);
    };
    const searchTableData = () => {
      resetClikedItems();
      resetSearch();
      initTable();
    };
    const loadingTable = ref(false);
    const tableData = ref([]);
    const initTable = async () => {
      const data = deepClone(toRaw(filters));
      if (data.maintainStatus === '') {
        data.maintainStatus = 999;
      }
      for (const item in data) {
        if (data[item] === '') {
          delete data[item];
        }
      }
      data.excludeId = '';
      const {
        mctServerAlarm
      } = await alarmQueryAll(data);
      tableData.value = mctServerAlarm.items.map((item, index) => {
        item.index = index;
        const cluster = item.clusterName.split(';');
        item.clusterNameRefactor = cluster[0];
        item.clusterIdRefactor = cluster[2];
        item.isClusterChecked = false;
        const zone = item.zoneName.split(';');
        item.zoneNameRefactor = zone[0];
        item.zoneIdRefactor = zone[1];
        item.isZoneChecked = false;
        item.isCheckChecked = false;
        return item;
      });
    };
    const computedTableData = computed(() => tableData.value.slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value));
    const currentPage = ref(1);
    const pageSize = ref(10);
    const itemNumber = computed(() => tableData.value.length);
    const handleSizeChange = val => {
      pageSize.value = val;
    };
    const batchMoveDialogVisible = ref(false);
    const batchMaintainDialogVisible = ref(false);
    const batchUnMaintainDialogVisible = ref(false);
    const batchDeleteDialogVisible = ref(false);
    const checkIdList = ref([]);
    const checkInfo = ref({});
    const handleMove = () => {
      if (!getCheckBoxSelect('Check')) return;
      if (clickedItems.get('cluster').size > 0 || clickedItems.get('zone').size > 0 || !isUnderSameZone()) {
        ElMessage({
          type: 'error',
          message: 'Batch move only support checks in a single zone'
        });
        return;
      } else {
        const checks = clickedItems.get('check');
        checkIdList.value = [];
        checks.forEach(item => {
          checkIdList.value.push(item.checkId);
          checkInfo.value = item;
        });
        batchMoveDialogVisible.value = true;
      }
    };
    const isUnderSameZone = () => {
      const checks = clickedItems.get('check');
      let zoneIdIndex = 0;
      let res = true;
      checks.forEach(check => {
        if (!zoneIdIndex) {
          zoneIdIndex = check.zoneId;
        }
        if (zoneIdIndex !== check.zoneId) {
          res = false;
        }
      });
      return res;
    };
    const handleManualTest = (e, data) => {
      showManualTestTrigger(e.target, {
        clusterId: data.clusterIdRefactor,
        zoneId: data.zoneIdRefactor,
        domainId: data.domainId,
        serverId: data.id,
        level: 'Server'
      });
    };
    const clusterIdList = ref([]);
    const zoneIdList = ref([]);
    const handleMaintain = isMaintain => {
      if (!getCheckBoxSelect('All')) return;
      clusterIdList.value = [];
      zoneIdList.value = [];
      checkIdList.value = [];
      const clusters = clickedItems.get('cluster');
      const zones = clickedItems.get('zone');
      const checks = clickedItems.get('check');
      if (clusters.size > 0) {
        for (const item of clusters) {
          clusterIdList.value.push(item);
        }
      }
      if (zones.size > 0) {
        for (const item of zones) {
          zoneIdList.value.push(item);
        }
      }
      if (checks.size > 0) {
        checks.forEach(item => {
          checkIdList.value.push(item.checkId);
        });
      }
      if (isMaintain) {
        batchMaintainDialogVisible.value = true;
      } else {
        batchUnMaintainDialogVisible.value = true;
      }
    };
    const handleDelete = () => {
      if (!getCheckBoxSelect('Check')) return;
      clusterIdList.value = [];
      zoneIdList.value = [];
      checkIdList.value = [];
      const clusters = clickedItems.get('cluster');
      const zones = clickedItems.get('zone');
      const checks = clickedItems.get('check');
      if (clusters.size > 0 || zones.size > 0) {
        ElMessage({
          type: 'error',
          message: 'Batch delete only supports checks deletion'
        });
        return;
      }
      if (checks.size > 0) {
        checks.forEach(item => {
          checkIdList.value.push(item.checkId);
        });
        batchDeleteDialogVisible.value = true;
      }
    };
    const clickedItems = new Map(Object.entries({
      cluster: new Set(),
      zone: new Set(),
      check: new Map()
    }));
    const resetClikedItems = () => {
      clickedItems.get('check').clear();
      clickedItems.get('zone').clear();
      clickedItems.get('check').clear();
    };
    const handleCheckboxChange = (data, level) => {
      if (level === 'CLUSTER') {
        if (data.isClusterChecked) {
          clickedItems.get('cluster').add(data.clusterIdRefactor);
        } else {
          clickedItems.get('cluster').delete(data.clusterIdRefactor);
        }
      } else if (level === 'ZONE') {
        if (data.isZoneChecked) {
          clickedItems.get('zone').add(data.zoneIdRefactor);
        } else {
          clickedItems.get('zone').delete(data.zoneIdRefactor);
        }
      } else {
        if (data.isCheckChecked) {
          if (data.serverName === 'All') {
            let index = false;
            tableData.value.forEach(rowData => {
              const rowDataIndex = rowData.index - 1;
              if (rowDataIndex === data.index) {
                index = true;
              }
              if (index && rowData.serverName !== 'All' && !rowData.zoneNameRefactor) {
                rowData.isCheckChecked = true;
                clickedItems.get('check').set(rowData.id, {
                  checkId: rowData.id,
                  zoneId: rowData.zoneIdRefactor,
                  clusterId: rowData.clusterIdRefactor
                });
              } else {
                index = false;
              }
            });
          } else {
            clickedItems.get('check').set(data.id, {
              checkId: data.id,
              zoneId: data.zoneIdRefactor,
              clusterId: data.clusterIdRefactor
            });
          }
        } else {
          if (data.serverName === 'All') {
            let index = false;
            tableData.value.forEach(rowData => {
              const rowDataIndex = rowData.index - 1;
              if (rowDataIndex === data.index) {
                index = true;
              }
              if (index && rowData.serverName !== 'All' && !rowData.zoneNameRefactor) {
                rowData.isCheckChecked = false;
                clickedItems.get('check').delete(rowData.id);
              } else {
                index = false;
              }
            });
          } else {
            clickedItems.get('check').delete(data.id);
          }
        }
      }
    };
    const getCheckBoxSelect = type => {
      const count = type === 'Check' ? clickedItems.get('check').size : clickedItems.get('cluster').size + clickedItems.get('zone').size + clickedItems.get('check').size;
      if (count === 0) {
        ElMessage.warning('Please select at least one!');
        return false;
      }
      return true;
    };
    watch(() => refreshTable.value, () => {
      searchTableData();
    });
    onMounted(() => {
      const [searchLevel, searchVal] = searchValue.value;
      if (searchLevel === '0') {
        filters.clusterName = searchVal;
      } else if (searchLevel === '1') {
        filters.serverName = searchVal;
      } else if (searchLevel === '2') {
        filters.url = searchVal;
      } else if (searchLevel === '3') {
        filters.zoneName = searchVal;
      }
      if (searchVal ?? '' !== '') {
        initTable();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_progress = _resolveComponent("el-progress");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
        modelValue: filters.clusterName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.clusterName = $event),
        placeholder: "Filter by cluster name"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: filters.zoneName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filters.zoneName = $event),
        placeholder: "Filter by zone name"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: filters.serverName,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filters.serverName = $event),
        placeholder: "Filter by check"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: filters.url,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filters.url = $event),
        placeholder: "Filter by URL"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_checkbox, {
        modelValue: filters.alerting,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => filters.alerting = $event)
      }, {
        default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("Alerting")])),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_button, {
        class: "ml-20",
        type: "primary",
        icon: _unref(Search),
        onClick: searchTableData
      }, {
        default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode(" Search ")])),
        _: 1
      }, 8, ["icon"]), _createVNode(_component_el_button, {
        plain: "",
        onClick: showMoreFilters,
        icon: isShowMoreFilters.value ? _unref(Minus) : _unref(Plus)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(isShowMoreFilters.value ? 'Hide filters' : 'More filters'), 1)]),
        _: 1
      }, 8, ["icon"])]), _withDirectives(_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
        modelValue: filters.dc,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => filters.dc = $event),
        placeholder: "Filter by data center"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: filters.service,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => filters.service = $event),
        placeholder: "Filter by service"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: filters.svrtype,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => filters.svrtype = $event),
        placeholder: "Filter by svrtype"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_select, {
        modelValue: filters.serverType,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => filters.serverType = $event),
        placeholder: "Filter by server type"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(serverTypeList.value, option => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: option.serverType,
            label: option.serverTypeName,
            value: option.serverType
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_select, {
        modelValue: filters.maintainStatus,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => filters.maintainStatus = $event),
        placeholder: "Filter by maintain status"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "Maintain",
          value: 1
        }), _createVNode(_component_el_option, {
          label: "Offline",
          value: 5
        })]),
        _: 1
      }, 8, ["modelValue"])], 512), [[_vShow, isShowMoreFilters.value]])]), _createElementVNode("div", _hoisted_5, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: computedTableData.value,
        style: {
          "width": "99%"
        },
        "row-key": "index",
        border: "",
        "default-expand-all": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "Cluster"
        }, {
          default: _withCtx(scope => [scope.row.clusterNameRefactor !== '' ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 0,
            class: "input-box",
            label: scope.row.clusterNameRefactor,
            modelValue: scope.row.isClusterChecked,
            "onUpdate:modelValue": $event => scope.row.isClusterChecked = $event,
            name: "type",
            "cluster-id": scope.row.clusterId,
            onChange: $event => handleCheckboxChange(scope.row, 'CLUSTER')
          }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "cluster-id", "onChange"])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "Zone"
        }, {
          default: _withCtx(scope => [scope.row.zoneNameRefactor !== '' ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 0,
            class: "input-box",
            label: scope.row.zoneNameRefactor,
            modelValue: scope.row.isZoneChecked,
            "onUpdate:modelValue": $event => scope.row.isZoneChecked = $event,
            name: "type",
            "zone-id": scope.row.zoneId,
            onChange: $event => handleCheckboxChange(scope.row, 'ZONE')
          }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "zone-id", "onChange"])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "serverName",
          label: "Check"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_checkbox, {
            class: "input-box",
            label: scope.row.serverName,
            modelValue: scope.row.isCheckChecked,
            "onUpdate:modelValue": $event => scope.row.isCheckChecked = $event,
            name: "type",
            "check-id": scope.row.id + '_' + scope.row.zoneId + '_' + scope.row.clusterId,
            onChange: $event => handleCheckboxChange(scope.row, 'CHECK')
          }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "check-id", "onChange"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "recentAlarmNum",
          label: "Recent 60 min",
          width: "160"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_progress, {
            percentage: string2percentage(scope.row.recentAlarmNum),
            "stroke-width": 8,
            status: "exception"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(scope.row.recentAlarmNum !== '0/0' ? scope.row.recentAlarmNum : ''), 1)]),
            _: 2
          }, 1032, ["percentage"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "lastTestTime",
          label: "Last Failure",
          width: "160"
        }), _createVNode(_component_el_table_column, {
          prop: "action",
          label: "Action",
          width: "120"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_6, [scope.row.clusterNameRefactor !== '' ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 0,
            class: "box-item",
            effect: "light",
            content: "Edit Cluster",
            placement: "top"
          }, {
            default: _withCtx(() => [_createElementVNode("a", {
              class: "mr-5",
              href: '/infrastructure/' + scope.row.clusterIdRefactor,
              target: "_blank",
              rel: "opener"
            }, [_createVNode(_component_el_button, {
              type: "success",
              icon: _unref(EditPen),
              size: "small",
              circle: ""
            }, null, 8, ["icon"])], 8, _hoisted_7)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), scope.row.id ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 1,
            class: "box-item",
            effect: "light",
            content: "Manual Test Check",
            placement: "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              id: "manual-test",
              type: "success",
              icon: _unref(CaretRight),
              size: "small",
              circle: "",
              onClick: $event => handleManualTest($event, scope.row)
            }, null, 8, ["icon", "onClick"])]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), scope.row.clusterNameRefactor !== '' ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 2,
            class: "box-item",
            effect: "light",
            content: "Cluster Status",
            placement: "top"
          }, {
            default: _withCtx(() => [_createElementVNode("a", {
              class: "ml-5",
              href: '/cluster-status/' + scope.row.clusterIdRefactor,
              rel: "opener",
              target: "_blank"
            }, [_createVNode(_component_el_button, {
              type: "warning",
              icon: _unref(Search),
              size: "small",
              circle: ""
            }, null, 8, ["icon"])], 8, _hoisted_8)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true)])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, loadingTable.value]])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        onClick: _cache[10] || (_cache[10] = $event => handleMaintain(true))
      }, {
        default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode(" Maintain ")])),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        onClick: _cache[11] || (_cache[11] = $event => handleMaintain(false))
      }, {
        default: _withCtx(() => _cache[21] || (_cache[21] = [_createTextVNode(" UnMaintain ")])),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        onClick: handleMove
      }, {
        default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode(" Move Check(s) ")])),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "danger",
        plain: "",
        onClick: handleDelete
      }, {
        default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode(" Delete Check(s) ")])),
        _: 1
      })]), _createVNode(_component_el_pagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[12] || (_cache[12] = $event => currentPage.value = $event),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[13] || (_cache[13] = $event => pageSize.value = $event),
        "page-sizes": [10, 20, 50],
        layout: "total, sizes, prev, pager, next",
        total: itemNumber.value,
        onSizeChange: handleSizeChange
      }, null, 8, ["current-page", "page-size", "total"])])]), _createVNode(BatchMoveDialog, {
        visible: batchMoveDialogVisible.value,
        "onUpdate:visible": _cache[14] || (_cache[14] = $event => batchMoveDialogVisible.value = $event),
        visibleModifiers: {
          sync: true
        },
        "check-id-list": checkIdList.value,
        "check-info": checkInfo.value
      }, null, 8, ["visible", "check-id-list", "check-info"]), _createVNode(BatchMaintainDialog, {
        visible: batchMaintainDialogVisible.value,
        "onUpdate:visible": _cache[15] || (_cache[15] = $event => batchMaintainDialogVisible.value = $event),
        visibleModifiers: {
          sync: true
        },
        "cluster-id-list": clusterIdList.value,
        "zone-id-list": zoneIdList.value,
        "check-id-list": checkIdList.value
      }, null, 8, ["visible", "cluster-id-list", "zone-id-list", "check-id-list"]), _createVNode(BatchUnmaintainDialog, {
        visible: batchUnMaintainDialogVisible.value,
        "onUpdate:visible": _cache[16] || (_cache[16] = $event => batchUnMaintainDialogVisible.value = $event),
        visibleModifiers: {
          sync: true
        },
        "cluster-id-list": clusterIdList.value,
        "zone-id-list": zoneIdList.value,
        "check-id-list": checkIdList.value
      }, null, 8, ["visible", "cluster-id-list", "zone-id-list", "check-id-list"]), _createVNode(BatchDeleteDialog, {
        visible: batchDeleteDialogVisible.value,
        "onUpdate:visible": _cache[17] || (_cache[17] = $event => batchDeleteDialogVisible.value = $event),
        visibleModifiers: {
          sync: true
        },
        "check-id-list": checkIdList.value
      }, null, 8, ["visible", "check-id-list"])], 64);
    };
  }
});